import starIcon from '../images/icons/star.svg';
import Format from './format';

const getAddressLabel = (primary, mailing) => {
  if (primary && mailing) return 'Primary & Mailing Address';
  if (primary) return 'Primary Address';
  if (mailing) return 'Mailing Address';

  return 'Other Address';
};

const normilizeValue = val => {
  return val || '';
};

const normalizeClientPanel = data => {
  const clientData = data.Cards.find(item => {
    return item.Title === 'Client';
  });

  const contactsData = data.Cards.find(item => {
    return item.Title === 'Contacts';
  });

  const addressesData = data.Cards.find(item => {
    return item.Title === 'Addresses';
  });

  const assignmentsData = data.Cards.find(item => {
    return item.Title === 'Assignments';
  });

  const underwritingData = data.Cards.find(item => {
    return item.Title === 'Underwriting';
  });

  return {
    client: {
      available: clientData.Available,
      data: [
        {
          type: 'default',
          label: 'Client ID',
          value: `${normilizeValue(clientData.Data.ClientId)}`,
        },
        {
          type: 'default',
          label: 'Client Code',
          value: `${normilizeValue(clientData.Data.Code)}`,
        },
        {
          type: 'default',
          label: 'Business Name',
          value: `${normilizeValue(clientData.Data.BusinessName)}`,
        },
        {
          type: 'custom',
          labelType: 'span',
          label: 'Website',
          valueType: 'anchor',
          value: `${normilizeValue(clientData.Data.Website)}`,
        },
      ],
    },
    contacts: {
      available: contactsData.Available,
      data: contactsData.Data.Contacts.map(item => {
        const primaryContact = item.PrimaryContact
          ? {
              type: 'custom',
              labelType: 'image',
              labelStyle: {
                height: '15px',
                width: '15px',
                marginRight: '4px',
              },
              label: `${starIcon}`,
              valueType: '',
              valueStyle: {
                fontSize: '12px',
                fontWeight: '700',
                lineHeight: '2',
                color: '#2b2a3a',
              },
              value: 'Primary Contact',
            }
          : {
              type: 'custom',
              label: '',
              value: '',
            };
        return [
          primaryContact,
          {
            type: 'default',
            label: 'Name',
            value: `${normilizeValue(item.FirstName)} ${normilizeValue(
              item.LastName,
            )}`,
          },
          {
            type: 'default',
            label: 'Phone',
            value: `${normilizeValue(item.Phone)}${
              item.PhoneExt ? `-${item.PhoneExt}` : ''
            }`,
          },
          {
            type: 'default',
            label: 'Mobile',
            value: `${normilizeValue(item.Mobile)}`,
          },
          {
            type: 'custom',
            labelType: 'span',
            label: 'Email',
            valueType: 'mail',
            value: `${normilizeValue(item.EmailAddress)}`,
          },
        ];
      }),
    },
    addresses: {
      available: addressesData.Available,
      data: addressesData.Data.Addresses.map(item => {
        const primaryAddress = item.Primary
          ? {
              type: 'custom',
              labelType: 'image',
              labelStyle: {
                height: '15px',
                width: '15px',
                marginRight: '4px',
              },
              label: `${starIcon}`,
              valueType: '',
              valueStyle: {
                fontSize: '12px',
                fontWeight: '700',
                lineHeight: '2',
                color: '#2b2a3a',
              },
              value: getAddressLabel(item.Primary, item.Mailing),
            }
          : {
              type: 'custom',
              label: '',
              valueType: '',
              valueStyle: {
                fontSize: '12px',
                fontWeight: '700',
                lineHeight: '2',
                color: '#2b2a3a',
              },
              value: getAddressLabel(item.Primary, item.Mailing),
            };
        return [
          primaryAddress,
          {
            type: 'custom',
            labelType: '',
            label: '',
            valueType: 'div',
            valueStyle: {
              fontWeight: '600',
              color: '#2b2a3a',
              letterSpacing: '0',
            },
            value: `${normilizeValue(item.Address1)}${
              item.Address2 ? `, ${item.Address2}` : ''
            }${item.Address3 ? `, ${item.Address3}` : ''}`,
          },
          {
            type: 'custom',
            labelType: '',
            label: '',
            valueType: 'div',
            valueStyle: {
              fontWeight: '600',
              color: '#2b2a3a',
              letterSpacing: '0',
            },
            value: `${item.City}, ${item.State}, ${item.ZipCode}`,
          },
        ];
      }),
    },
    assignments: {
      available: assignmentsData.Available,
      data: [
        {
          type: 'default',
          label: 'Account Manager',
          value: `${normilizeValue(assignmentsData.Data.AccountManager)}`,
        },
        {
          type: 'default',
          label: 'Last Submit Date',
          value: `${Format.formatDate(
            normilizeValue(assignmentsData.Data.LastSubmittedDate),
          )}`,
        },
        {
          type: 'default',
          label: 'First Policy Date',
          value: `${Format.formatDate(
            normilizeValue(assignmentsData.Data.FirstPolicyDate),
          )}`,
        },
        {
          type: 'default',
          label: 'Client Status',
          value: `${normilizeValue(assignmentsData.Data.ClientStatus)}`,
        },
      ],
    },
    underwriting: {
      available: underwritingData.Available,
      data: [
        {
          type: 'default',
          label: 'Business Class',
          value: `${normilizeValue(
            underwritingData.Data.BusinessClassifcation,
          )}`,
        },
        {
          type: 'default',
          label: 'Web Business Class',
          value: `${normilizeValue(underwritingData.Data.WebBusinessClass)}`,
        },
        {
          type: 'default',
          label: 'Date Business Established',
          value: `${Format.formatDate(
            normilizeValue(underwritingData.Data.DateEstablishedBusiness),
          )}`,
        },
        {
          type: 'default',
          label: 'Years of Industry Experience (Owner)',
          value: `${
            underwritingData.Data.YearsOfIndustryExperience
              ? `${underwritingData.Data.YearsOfIndustryExperience} yrs.`
              : ' yrs.'
          }`,
        },
        {
          type: 'default',
          label: 'Revenue Prior',
          value: `${normilizeValue(underwritingData.Data.RevenuePrior)}`,
        },
        {
          type: 'default',
          label: 'Revenue Current',
          value: `${normilizeValue(underwritingData.Data.RevenueCurrent)}`,
        },
        {
          type: 'default',
          label: 'Revenue Projected',
          value: `${normilizeValue(underwritingData.Data.RevenueProjected)}`,
        },
        {
          type: 'default',
          label: 'Number of Employees',
          value: `${normilizeValue(underwritingData.Data.NumberOfEmployee)}`,
        },
        {
          type: 'default',
          label: 'FEIN',
          value: `${normilizeValue(underwritingData.Data.FEIN)}`,
        },
        {
          type: 'default',
          label: 'Legal Entity',
          value: `${normilizeValue(underwritingData.Data.LegalEntity)}`,
        },
        {
          type: 'default',
          label: 'Prior Claim',
          value: `${underwritingData.Data.PriorClaim ? 'Y' : 'N'}`,
        },
        {
          type: 'default',
          label: 'Description of Operation',
          value: `${normilizeValue(
            underwritingData.Data.DescriptionOfOperation,
          )}`,
        },
      ],
    },
  };
};

export default normalizeClientPanel;
